import * as React from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {LocationalSummery} from "./LocationalSummary";
import {RoadLocationalDetails} from "./RoadLocationalDetails";
import LocationalState, {LocationalRoadObject} from "../LocationalState";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import {
    closeLaneModal,
    CloseLaneModal,
    SetFeatureInDetailsModal,
    setFeatureInDetailsModal, updateLanes, UpdateLanes,
} from "../actions";
import LaneModal from "./LaneModal";
import {Locational} from "../../../../integration/representation/feature";
import {getRefLink} from "../../../../locationalUtilities";



interface DispatchProps {
    doSetFeatureInDetailsModal: SetFeatureInDetailsModal;
    doUpdateLanes: UpdateLanes;
    doCloseLaneModal: CloseLaneModal;
}

interface StateProps {
    showModal: boolean;
    feature: LocationalRoadObject;
    featureName: string;
    featureTypeName: string;
    locationalSelectedForLaneModal: Locational;
}

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        showModal: selectors.showLocationalDetailsModal(state),
        feature: selectors.featureInDetailsModal(state),
        featureName: selectors.featureNameInDetailsModal(state),
        featureTypeName: selectors.featureTypeNameInDetailsModal(state),
        locationalSelectedForLaneModal: selectors.locationalSelectedForLaneModal(state)
    };
};

function getHeading(featureName: string, featureTypeName: string): JSX.Element {
    if (featureName.includes(featureTypeName)) {
        return <span className={"bold"}>{featureName}</span>;
    }
    return <span>
        <span className={"bold"}>{featureName}</span>
        {" av typen "}
        <span className={"bold"}>{featureTypeName}</span>
    </span>
}

const mapDispatchToProps: DispatchProps = ({
    doSetFeatureInDetailsModal: setFeatureInDetailsModal,
    doUpdateLanes: updateLanes,
    doCloseLaneModal: closeLaneModal,
});

type Props = StateProps & DispatchProps;

class Component extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
        this.state = {
        }
    }

    render() {

        let {feature, featureName, featureTypeName, locationalSelectedForLaneModal, doCloseLaneModal, doUpdateLanes} = this.props;

        return (
            <Modal show={true} onHide={() => this.closeModal()} className={"autolocalize-modal"}>
                <ModalHeader>
                    <ModalTitle>Detaljert stedfesting for {getHeading(featureName, featureTypeName)}</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <div>
                        <LocationalSummery feature={feature} />
                        <br />
                        {feature.locational &&
                            feature.locational.locationals.map(locational => {
                                const refLink = getRefLink(locational)
                                return(
                                    <div key={refLink}>
                                        <RoadLocationalDetails
                                            key={refLink}
                                            feature={feature}
                                            locational={locational}
                                        />
                                        <br/>
                                    </div>
                                )
                            })
                        }

                        {locationalSelectedForLaneModal &&
                            <LaneModal
                                roadObject={feature}
                                locational={locationalSelectedForLaneModal}
                                closeModal={doCloseLaneModal}
                                updateLanes={doUpdateLanes}
                            />
                        }
                    </div>
                </ModalBody>
                <ModalFooter>

                    <Button onClick={() => this.closeModal()}>OK</Button>
                </ModalFooter>
            </Modal>
        )
    }

    closeModal() {
        this.props.doSetFeatureInDetailsModal(null);
    }
}
export const LocationalDetailsModal = connect(mapStateToProps, mapDispatchToProps)(Component);
